<script setup lang="ts">
import type { ProductPage } from "@/types";

const { product, slug } = defineProps<{
  product: ProductPage;
  slug: string;
  uuid: string;
}>();

const displayImage = ref(product.swatchImage);

const productPrice = useProductPriceName(product.price);
const priceColor = await useProductPriceColor(productPrice);

const onMouseEnter = () => {
  if (product.inspirationalImage.filename) {
    displayImage.value = product.inspirationalImage;
  }
};

const onMouseLeave = () => {
  displayImage.value = product.swatchImage;
};
</script>

<template>
  <div v-editable="product" class="flex flex-col gap-6">
    <div class="relative">
      <div class="absolute right-0 py-2.5 pl-2.5 md:pr-2.5">
        <FavoriteButton :product-uuid="uuid" />
      </div>
      <NuxtLink :href="`/${slug}`">
        <Image
          class="cursor-pointer -mx-2.5 md:mx-0"
          :blok="{
            image: displayImage,
            ratio: '1x1',
          }"
          @mouseenter="onMouseEnter"
          @mouseleave="onMouseLeave"
        />
      </NuxtLink>
    </div>
    <div class="flex flex-col gap-4">
      <NuxtLink class="flex justify-between" :href="`/${slug}`">
        <span class="font-helvetica-bold text-lg lg:text-xl">{{
          product.name
        }}</span>
        <NuxtImg
          width="24px"
          height="24px"
          src="/icon/chevron-right-rounded.svg"
          alt="Chevron right"
        />
      </NuxtLink>
      <div class="flex gap-2.5 text-[13px] items-center leading-none">
        <span class="py-[5px]">{{ product.type }}</span>
        <span class="py-[5px]">{{ product.use }}</span>
        <span class="py-[5px]">{{ product.backgroundColor }}</span>
        <div class="py-[5px] flex gap-[5px]">
          <span
            class="h-2.5 w-2.5 rounded-full"
            :style="{ backgroundColor: priceColor }"
          />
          <span>{{ productPrice }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
